export default __webpack_public_path__ + "static/media/red.89d087db.png";